export default __webpack_public_path__ + "static/media/avatar-5.a5c59cee.jpg";